import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { PMC_REPLACEMENT_CHECKLIST } from './hoaProductCatalog.js';

const STORAGE_KEY = 'nmr_pmc_checklist_v1';

function loadChecked() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch {
    return {};
  }
}

function PmcReplacementChecklist({ showProgress = true }) {
  const [checked, setChecked] = useState(loadChecked);

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(checked));
    } catch {
      // ignore quota errors
    }
  }, [checked]);

  const { total, done } = useMemo(() => {
    const allItems = PMC_REPLACEMENT_CHECKLIST.flatMap((phase) => phase.items);
    const completed = allItems.filter((item) => checked[item.id]).length;
    return { total: allItems.length, done: completed };
  }, [checked]);

  const toggle = useCallback((id) => {
    setChecked((prev) => ({ ...prev, [id]: !prev[id] }));
  }, []);

  const reset = useCallback(() => {
    setChecked({});
  }, []);

  const pct = total > 0 ? Math.round((done / total) * 100) : 0;

  return (
    <div className="pmc-checklist">
      {showProgress && (
        <div className="pmc-checklist-progress" role="status" aria-live="polite">
          <div className="pmc-checklist-progress-label">
            <span>{done} of {total} steps complete</span>
            <span>{pct}%</span>
          </div>
          <div className="pmc-checklist-progress-bar" aria-hidden="true">
            <div className="pmc-checklist-progress-fill" style={{ width: `${pct}%` }} />
          </div>
          {done > 0 && (
            <button type="button" className="pmc-checklist-reset" onClick={reset}>
              Reset checklist
            </button>
          )}
        </div>
      )}

      <div className="pmc-checklist-phases">
        {PMC_REPLACEMENT_CHECKLIST.map((phase) => (
          <article key={phase.id} className="pmc-checklist-phase">
            <h3>{phase.phase}</h3>
            <p className="pmc-checklist-summary">{phase.summary}</p>
            <ul className="pmc-checklist-items">
              {phase.items.map((item) => (
                <li key={item.id}>
                  <label className="pmc-checklist-item">
                    <input
                      type="checkbox"
                      checked={!!checked[item.id]}
                      onChange={() => toggle(item.id)}
                    />
                    <span>{item.label}</span>
                  </label>
                </li>
              ))}
            </ul>
          </article>
        ))}
      </div>
    </div>
  );
}

export default PmcReplacementChecklist;